import _ from 'underscore';

import { AccessType } from 'girder/constants';
import eventStream from 'girder/utilities/EventStream';
import { getCurrentUser } from 'girder/auth';
import Panel from 'girder_plugins/slicer_cli_web/views/Panel';
import AnnotationModel from 'girder_plugins/large_image/models/AnnotationModel';
import {events as girderEvents} from 'girder';

import events from '../events';
import showSaveAnnotationDialog from '../dialogs/saveAnnotation';

import annotationSelectorWidget from '../templates/panels/annotationSelector.pug';
import '../stylesheets/panels/annotationSelector.styl';
import { restRequest } from 'girder/rest';
import StyleCollection from '../collections/StyleCollection';
import StyleModel from '../models/StyleModel';
// Too many elements in the draw panel will crash the browser,
// so we only allow editing of annnotations with less than this
// many elements.
const MAX_ELEMENTS_LIST_LENGTH = 5000;

/**
 * Generate a new "random" element id (24 random 16 digits).
 */
function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + s4() + s4() + s4() + s4();
}

/**
 * Create a panel controlling the visibility of annotations
 * on the image view.
 */
var AnnotationSelector = Panel.extend({
    events: _.extend(Panel.prototype.events, {
        'click .h-annotation-name': '_editAnnotation',
        'click .h-toggle-annotation': 'toggleAnnotation',
        'click .h-delete-annotation': 'deleteAnnotation',
        'click .h-create-annotation': 'createAnnotation',
        'click .h-edit-annotation-metadata': 'editAnnotationMetadata',
        'click .h-show-all-annotations': 'showAllAnnotations',
        'click .h-hide-all-annotations': 'hideAllAnnotations',
        'mouseenter .h-annotation': '_highlightAnnotation',
        'mouseleave .h-annotation': '_unhighlightAnnotation',
        'change #h-toggle-labels': 'toggleLabels',
        'change #h-toggle-interactive': 'toggleInteractiveMode',
        'change #h-toggle-allow-rotation': 'toggleAllowRotation',
        'input #h-annotation-opacity': '_changeGlobalOpacity',
        'input #h-annotation-fill-opacity': '_changeGlobalFillOpacity',
        'click .h-annotation-select-by-region': 'selectAnnotationByRegion',
        'click .h-annotation-group-name': '_toggleExpandGroup',
        'click #h-browse-annotations': 'browseAnnotationFile',
        'change #h-annotation-import': 'importAnnotationsOnItem',
        'click #h-download-annotation': 'downloadAnnotations',
        'click .h-download-annotation-group': 'downloadAnnotationsByGroup'
    }),

    /**
     * Create the panel.
     *
     * @param {object} settings
     * @param {AnnotationCollection} settings.collection
     *     The collection representing the annotations attached
     *     to the current image.
     */
    initialize(settings = {}) {
        this._expandedGroups = new Set();
        this.forAnnotation = '';
        this.forGroup = '';
        this._opacity = settings.opacity || 0.9;
        this._fillOpacity = settings.fillOpacity || 1.0;
        this._showAllAnnotationsState = false;
        this.listenTo(this.collection, 'sync remove update reset change:displayed change:loading', this._debounceRender);
        this.listenTo(this.collection, 'change:highlight', this._changeAnnotationHighlight);
        this.listenTo(eventStream, 'g:event.job_status', _.debounce(this._onJobUpdate, 500));
        this.listenTo(eventStream, 'g:eventStream.start', this._refreshAnnotations);
        this.listenTo(this.collection, 'change:annotation change:groups', this._saveAnnotation);
        this.listenTo(girderEvents, 'g:login', () => {
            this.collection.reset();
            this._parentId = undefined;
        });
        this.updateGroups();
        this.elemPosition = 0;
    },

    updateGroups(){
        this._groups = new StyleCollection();
        this._style = new StyleModel({
            id: 'default'
        });
        this.listenTo(this._groups, 'update', this.render);
        this._groups.fetch().done(() => {
            // ensure the default style exists
            if (this._groups.has('default')) {
                this._style.set(this._groups.get('default').toJSON());
            } else {
                this._groups.add(this._style.toJSON());
                this._groups.get(this._style.id).save();
            }
            this.styleGroups = JSON.parse(JSON.stringify(this._groups));
        });
    },

    render() {
        this._debounceRenderRequest = null;
        const annotationGroups = this._getAnnotationGroups();
        const groupKeys = _.keys(annotationGroups);
        if (this.styleGroups != undefined) {
            this.styleGroups.forEach(style => {
                let key = groupKeys.find(a => a == style.id);
                if (key != undefined) {
                    annotationGroups[key][0]['borderStyle'] = style.lineColor;
                    annotationGroups[key][0]['backgroundStyle'] = style.fillColor;
                }
            });
        }
        this.$('[data-toggle="tooltip"]').tooltip('destroy');
        if (!this.viewer) {
            this.$el.empty();
            return;
        }
        this.$el.html(annotationSelectorWidget({
            id: 'annotation-panel-container',
            title: 'Annotations',
            activeAnnotation: this._activeAnnotation ? this._activeAnnotation.id : '',
            showLabels: this._showLabels,
            user: getCurrentUser() || {},
            writeAccess: this._writeAccess,
            opacity: this._opacity,
            fillOpacity: this._fillOpacity,
            interactiveMode: this._interactiveMode,
            allowRotation: this._allowRotation,
            expandedGroups: this._expandedGroups,
            annotationGroups,
            imageName: this._imageName,
            easyAnnotation: this.easy_annotation,
            _
        }));
        this.$('.s-panel-content').collapse({toggle: false});
        this.$('[data-toggle="tooltip"]').tooltip({container: 'body'});
        this._changeGlobalOpacity();
        this._changeGlobalFillOpacity();
        if (this._showAllAnnotationsState) {
            this.showAllAnnotations();
        }
        var scroll_div = $(`.annotation-element-container`);
        this.containerHeight = $(`.annotation-element-container`);
        this.containerHeight.scrollTop(this.groupPosition);
        if ($(`.h-annotation.h-active-annotation`)[0] && this.forGroup != 'group') {
            this.annotationHeight = $(`.h-annotation.h-active-annotation`)[0].offsetTop;
            this.forAnnotation = 'annotation';
        }
        if (this.forAnnotation == 'annotation' && scroll_div[0] != undefined) {
            scroll_div.scrollTop(this.annotationHeight - scroll_div[0].offsetTop - 40);
        }
        else if (this.forGroup == 'group'  && scroll_div[0] != undefined) {
            if (this.groupPosition <= (scroll_div[0].offsetTop + 40)) {
                scroll_div.scrollTop(0);
            }
            else {
                scroll_div.scrollTop(this.groupPosition - scroll_div[0].offsetTop);
            }
        }
        return this;
    },

    _debounceRender() {
        if (!this._debounceRenderRequest) {
            this._debounceRenderRequest = window.requestAnimationFrame(() => { this.render(); });
        }
        return this;
    },

    /**
     * Set the ItemModel associated with the annotation collection.
     * As a side effect, this resets the AnnotationCollection and
     * fetches annotations from the server associated with the
     * item.
     *
     * @param {ItemModel} item
     */
    setItem(item) {
        if (this._parentId === item.id) {
            return;
        }

        this.parentItem = item;
        this._parentId = item.id;

        if (!this._parentId) {
            this.collection.reset();
            this._debounceRender();
            return;
        }
        this.collection.offset = 0;
        this.collection.reset();
        this.collection.fetch({itemId: this._parentId});
        this._fetchImage(this._parentId);
        this.createAnnotationStyles();
        return this;
    },

    getSettings() {
        restRequest({
            url: `HistomicsTK/settings`
        }).then((settings) => {
            this.easy_annotation = settings['histomicstk.easy_annotation'];
            if (this.easy_annotation != undefined && this.easy_annotation) {
                //To highlight label and interactive mode when easy annotation is enabled
                this._showLabels = true;
                this.trigger('h:toggleLabels', {
                    show: this._showLabels
                });
                this._interactiveMode = true;
                this.trigger('h:toggleInteractiveMode', this._interactiveMode);
                restRequest({
                    url: `folder/${this.folderId}`
                }).then((folderInfo) => {
                    if (folderInfo._accessLevel == 1 || folderInfo._accessLevel == 2) {
                        this.newAnnotation();
                    }
                });
            }
        });
    },

    _fetchImage(itemId) {
        restRequest({
            url: `item/${itemId}`
        }).then((_items) => {
            this._imageName = _items.name.replace(/\.[^/.]+$/, "");
            // Get folder Id from image model to check access level for the user
            this.folderId = _items.folderId;
            this.getSettings();
        });
    },

    /**
     * Set the image "viewer" instance.  This should be a subclass
     * of `large_image/imageViewerWidget` that is capable of rendering
     * annotations.
     */
    setViewer(viewer) {
        this.viewer = viewer;
        return this;
    },

    /**
     * Toggle the renderering of a specific annotation.  Sets the
     * `displayed` attribute of the `AnnotationModel`.
     */
    toggleAnnotation(evt) {
        var id = $(evt.currentTarget).parents('.h-annotation').data('id');
        var model = this.collection.get(id);

        // any manual change in the display state will reset the "forced display" behavior
        this._showAllAnnotationsState = false;
        model.set('displayed', !model.get('displayed'));
        if (!model.get('displayed')) {
            model.unset('highlight');
        }
    },

    /**
     * Delete an annotation from the server.
     */
    deleteAnnotation(evt, deleteId) {
        if (evt != undefined) {
            const id = $(evt.currentTarget).parents('.h-annotation').data('id');
            const model = this.collection.get(id);
            if (model) {
                const name = (model.get('annotation') || {}).name || 'unnamed annotation';
                events.trigger('h:confirmDialog', {
                    title: 'Warning',
                    message: `Are you sure you want to delete ${name}?`,
                    submitButton: 'Delete',
                    onSubmit: () => {
                        this.trigger('h:deleteAnnotation', model);
                        model.unset('displayed');
                        model.unset('highlight');
                        this.collection.remove(model);
                        model.destroy();
                        this.newAnnotation(this.collection);
                    }
                });
            }
        } else {
            const model = this.collection.get(deleteId);
            this.trigger('h:deleteAnnotation', model);
            model.unset('displayed');
            model.unset('highlight');
            this.collection.remove(model);
            model.destroy();
        }        
    },

    editAnnotationMetadata(evt) {
        const id = $(evt.currentTarget).parents('.h-annotation').data('id');
        const model = this.collection.get(id);
        this.listenToOnce(
            showSaveAnnotationDialog(model, {title: 'Edit annotation'}, this._groups, this._style, true),
            'g:submit',
            () => {
                model.save().done(() => {
                    if (model.get('displayed')) {
                        this.trigger('h:redraw', model);
                    }
                });
            }
        );
    },

    _onJobUpdate(evt) {
        if (this.parentItem && evt.data.status > 2) {
            this._refreshAnnotations();
        }
    },

    getUpdatedAnnotations(transferredAnnotationSet) {
        if (!this.parentItem || !this.parentItem.id) {
            return;
        }
        var models = this.collection.indexBy(_.property('id'));
        this.collection.offset = 0;
        this.collection.fetch({itemId: this.parentItem.id}).then(() => {
            var activeId = (this._activeAnnotation || {}).id;
            this.collection.each((model) => {
                if (models[model.id] != undefined && models[model.id].get('displayed')) {
                    model.set('displayed', true);
                }
            });
            this._debounceRender();
            this._activeAnnotation = null;
            if (activeId) {
                this._setActiveAnnotation(this.collection.get(activeId));
            }
            // remove annotations that are displayed but have been deleted
            Object.keys(models).forEach((id) => {
                if (!this.collection.get(id) && models[id].get('displayed')) {
                    this.viewer.removeAnnotation(models[id]);
                }
            });
            return null;
        });
        transferredAnnotationSet.set('displayed', true);
    },

    _refreshAnnotations() {
        if (!this.parentItem || !this.parentItem.id) {
            return;
        }
        var models = this.collection.indexBy(_.property('id'));
        this.collection.offset = 0;
        this.collection.fetch({itemId: this.parentItem.id}).then(() => {
            var activeId = (this._activeAnnotation || {}).id;
            this.collection.each((model) => {
                if (!_.has(models, model.id)) {
                    model.set('displayed', true);
                } else {
                    if (models[model.id].get('displayed')) {
                        if (model.get('_version') !== models[model.id].get('_version')) {
                            model.refresh(true);
                            model.set('displayed', true);
                        } else {
                            model._centroids = models[model.id]._centroids;
                        }
                    }
                    // set without triggering a change; a change reloads and
                    // rerenders, which is only done if it has changed (above)
                    model.attributes.displayed = models[model.id].get('displayed');
                }
            });
            this._debounceRender();
            this._activeAnnotation = null;
            if (activeId) {
                this._setActiveAnnotation(this.collection.get(activeId));
            }
            // remove annotations that are displayed but have been deleted
            Object.keys(models).forEach((id) => {
                if (!this.collection.get(id) && models[id].get('displayed')) {
                    this.viewer.removeAnnotation(models[id]);
                }
            });
            return null;
        });
    },

    toggleLabels(evt) {
        this._showLabels = !this._showLabels;
        this.trigger('h:toggleLabels', {
            show: this._showLabels
        });
    },

    toggleInteractiveMode(evt) {
        this._interactiveMode = !this._interactiveMode;
        this.trigger('h:toggleInteractiveMode', this._interactiveMode);
    },

    toggleAllowRotation(evt) {
        this._allowRotation = !this._allowRotation;
        this.trigger('h:toggleAllowRotation', this._allowRotation);
    },

    interactiveMode() {
        return this._interactiveMode;
    },

    allowRotation() {
        return this._allowRotation;
    },

    _editAnnotation(evt) {
        var id = $(evt.currentTarget).parents('.h-annotation').data('id');
        this.forAnnotation = 'annotation';
        this.forGroup = '';
        this.annotationHeight = $(evt.currentTarget).parents('.h-annotation')[0].offsetTop;
        this.containerHeight.scrollTop(this.annotationHeight);
        this.editAnnotation(this.collection.get(id));
    },

    editAnnotation(model, isChanged) {
        //To check if there is group transfer and show annotations in draw widget to the corresponding annotation set in annotation selector widget after group transfer
        let checkChanged = isChanged != undefined ? isChanged : true;
        // deselect the annotation if it is already selected
        if (this._activeAnnotation && model && this._activeAnnotation.id === model.id && checkChanged) {
            this._activeAnnotation = null;
            this.trigger('h:editAnnotation', null);
            this._debounceRender();
            return;
        }

        if (!this._writeAccess(model)) {
            events.trigger('g:alert', {
                text: 'You do not have write access to this annotation.',
                type: 'warning',
                timeout: 2500,
                icon: 'info'
            });
            return;
        }
        this._setActiveAnnotation(model);
    },

    _setActiveAnnotation(model) {
        this._activeAnnotation = model;
        if (!((model.get('annotation') || {}).elements || []).length || model.get('annotation').elements != undefined) {
            // Only load the annotation if it hasn't already been loaded.
            // Technically, an annotation *could* have 0 elements, in which
            // case loading it again should be quick.  There doesn't seem
            // to be any other way to detect an unloaded annotation.
            model.set('loading', true);
            model.fetch().done(() => {
                this._setActiveAnnotationWithoutLoad(model);
            }).always(() => {
                model.unset('loading');
            });
        } else {
            this._setActiveAnnotationWithoutLoad(model);
        }
    },

    _setActiveAnnotationWithoutLoad(model) {
        const numElements = ((model.get('annotation') || {}).elements || []).length;
        if (this._activeAnnotation && this._activeAnnotation.id !== model.id) {
            return;
        }
        model.set('displayed', true);

        if (numElements > MAX_ELEMENTS_LIST_LENGTH) {
            events.trigger('g:alert', {
                text: 'This annotation has too many elements to be edited.',
                type: 'warning',
                timeout: 5000,
                icon: 'info'
            });
            this._activeAnnotation = null;
            this.trigger('h:editAnnotation', null);
        } else {
            this.trigger('h:editAnnotation', model);
        }
    },

    createAnnotation(evt) {
        var model = new AnnotationModel({
            itemId: this.parentItem.id,
            annotation: {}
        });
        this.updateGroups();
        this.listenToOnce(
            showSaveAnnotationDialog(model, {title: 'Create annotation'}, this._groups, this._style, false),
            'g:submit',
            () => {
                if (model.attributes.annotation["name"] != undefined) {
                    model.save().done(() => {
                        model.set('displayed', true);
                        const groups = model.get('groups') || [];
                        const groupName = model.get('groupName') || '';
                        if (!groups.length && groupName == '') {
                            groups.push(null);
                            this._expandedGroups.add('default');
                        } else if (!groups.length && groupName != '') {
                            groups.push(groupName);
                            this._expandedGroups.add(groupName);
                        }
                        this.collection.add(model);
                        this.trigger('h:editAnnotation', model);
                        this._activeAnnotation = model;
                    });
                }
            }
        );
    },

    newAnnotation(collection) {
        //To get current logged in user details for creating annotation set and showing them
        var currentUser = getCurrentUser().attributes;
        // This will be check for deleting annotation set
        if (collection != undefined) {
            if (collection.models.length == 0) {
                var model = new AnnotationModel({
                    itemId: this.parentItem.id,
                    annotation: {
                        name: currentUser.login.toLowerCase()
                    }
                });
                model.save().done(() => {
                    model.set('displayed', true);
                    this.collection.add(model);
                });
                this.trigger('h:newAnnotation', model);
            } else {
                let data = collection.models.find(ann => ann.attributes.annotation.name == currentUser.login.toLowerCase());
                var selectedAnnotation = collection.models.filter(s => s.attributes.creatorId == currentUser._id);
                if (data) {
                    if ((this._activeAnnotation == undefined) || (this._activeAnnotation.id != data.attributes._id)) {
                        this.editAnnotation(this.collection.get(data.attributes._id));
                        this._activeAnnotation = {
                            'id': data.attributes._id
                        };
                    }
                } else if (selectedAnnotation.length != 0) {
                    if ((this._activeAnnotation == undefined) || (this._activeAnnotation.id != selectedAnnotation[0].attributes._id)) {
                        this.editAnnotation(this.collection.get(selectedAnnotation[0].attributes._id));
                        this._activeAnnotation = {
                            'id': selectedAnnotation[0].attributes._id
                        };
                    }
                } else {
                    var model = new AnnotationModel({
                        itemId: this.parentItem.id,
                        annotation: {
                            name: currentUser.login.toLowerCase()
                        }
                    });
                    model.save().done(() => {
                        model.set('displayed', true);
                        this.collection.add(model);
                    });
                    this.trigger('h:newAnnotation', model);
                }
            }
        } else {
            // To get all annotation sets specific to image Id
            restRequest({
                url: `annotation/item/${this.parentItem.id}`
            }).then((annItems) => {
                //If there are no annotation sets present for Image, then annotation set with user login name will be created
                if (annItems.length == 0) {
                    var model = new AnnotationModel({
                        itemId: this.parentItem.id,
                        annotation: {
                            name: currentUser.login.toLowerCase()
                        }
                    });
                    model.save().done(() => {
                        model.set('displayed', true);
                        this.collection.add(model);
                    });
                    this.trigger('h:newAnnotation', model);
                // If there are any annotation sets present for image
                } else {
                    //Firstly data will check for user login name annotation set to show in viewer and draw widget
                    let data = annItems.find(ann => ann.annotation.name == currentUser.login.toLowerCase());
                    //selectedAnnotation will check for annotation set created by user
                    var selectedAnnotation = annItems.filter(s => s.creatorId == currentUser._id);
                    if (data) {
                        //To show annotations in viewer and draw widget
                        this.editAnnotation(this.collection.get(data._id));
                        this._activeAnnotation = {
                            'id': data._id
                        };
                    } else if (selectedAnnotation.length != 0) {
                        this.editAnnotation(this.collection.get(selectedAnnotation[0]._id));
                        this._activeAnnotation = {
                            'id': selectedAnnotation[0]._id
                        };
                    //If there are no annotation sets created by user then annotation set with user login name will be created
                    } else {
                        var model = new AnnotationModel({
                            itemId: this.parentItem.id,
                            annotation: {
                                name: currentUser.login.toLowerCase()
                            }
                        });
                        model.save().done(() => {
                            model.set('displayed', true);
                            this.collection.add(model);
                        });
                        this.trigger('h:newAnnotation', model);
                    }
                }
            });
        }
    },

    downloadAnnotations(evt) {
        evt.stopPropagation();
        restRequest({
            url: `annotation/item/${this.parentItem.id}`
        }).then((downloadItems) => {
            var annotationData = JSON.stringify(downloadItems);
            var a = document.createElement('a');
            var dataBlob = new Blob([annotationData], {
                type: "text/json"
            });
            var objUrl = URL.createObjectURL(dataBlob);
            a.href = objUrl;
            a.download = `${this._imageName}_annotations.json`;
            a.click();
        });
    },

    downloadAnnotationsByGroup(evt) {
        let groupName = $(evt.currentTarget).parent().parent().parent().data('groupName');
        evt.stopPropagation();
        restRequest({
            url: `annotation/item/${this.parentItem.id}`
        }).then((annotations) => {
            let annotationData = [];
            if (groupName == 'default') {
                annotationData = annotations.filter(a => a.groups.indexOf(null) >= 0);
            } else {
                annotationData = annotations.filter(a => a.groups.indexOf(groupName) >= 0);
            }
            var annotationGroupData = JSON.stringify(annotationData);
            var a = document.createElement('a');
            var dataBlob = new Blob([annotationGroupData], {
                type: "text/json"
            });
            var objUrl = URL.createObjectURL(dataBlob);
            a.href = objUrl;
            a.download = `${this._imageName}_${groupName}_annotations.json`;
            a.click();
        });
    },

    browseAnnotationFile(evt){
        evt.stopPropagation();
        document.getElementById('h-annotation-import').click();
    },

    importAnnotationsOnItem(evt) {
        let files = document.getElementById('h-annotation-import').files;
        if (files.length <= 0) {
            alert('Please browse a file to upload');
            return false;
        }
        var fr = new FileReader();
        fr.onload = (e) => {
            let result;
            try {
                result = JSON.parse(e.target.result);
            }
            catch (e) {
                // The JSON was invalid, `e` has some further information
                alert('Please upload file in proper JSON fromat');
                return false;
            }
            let formatted = JSON.stringify(result, null, 2);
            restRequest({
                url: `/annotation/item/${this.parentItem.id}`,
                contentType: 'application/json',
                data: formatted,
                method: 'POST'
            }).then((result) => {
                events.trigger('g:alert', {
                    icon: 'ok',
                    text: 'Successfully imported annotations',
                    type: 'success',
                    timeout: 1000
                });
                window.setTimeout(function () {
                    window.location.reload();
                }, 1000);
            });
        }
        fr.readAsText(files.item(0));
    },

    _saveAnnotation(annotation) {
        if (!annotation._saving && !annotation._inFetch && !annotation.get('loading')) {
            annotation._saving = true;
            this.trigger('h:redraw', annotation);
            annotation.save().always(() => {
                annotation._saving = false;
            });
        }
    },

    _writeAccess(annotation) {
        return annotation.get('_accessLevel') >= AccessType.ADMIN;
    },

    showAllAnnotations() {
        this._showAllAnnotationsState = true;
        this.collection.each((model) => {
            model.set('displayed', true);
        });
    },

    hideAllAnnotations() {
        this._showAllAnnotationsState = false;
        this.collection.each((model) => {
            model.set('displayed', false);
        });
    },

    selectAnnotationByRegion() {
        const btn = this.$('.h-annotation-select-by-region');
        // listen to escape key
        $(document).on('keydown.h-annotation-select-by-region', (evt) => {
            if (evt.keyCode === 27) {
                btn.removeClass('active');
                $(document).off('keydown.h-annotation-select-by-region');
                this.parentView.trigger('h:selectElementsByRegionCancel');
            }
        });
        this.listenToOnce(this.parentView, 'h:selectedElementsByRegion', () => {
            btn.removeClass('active');
            $(document).off('keydown.h-annotation-select-by-region');
        });

        if (!btn.hasClass('active')) {
            btn.addClass('active');
            this.parentView.trigger('h:selectElementsByRegion');
        } else {
            btn.removeClass('active');
            $(document).off('keydown.h-annotation-select-by-region');
            this.parentView.trigger('h:selectElementsByRegionCancel');
        }
    },

    _highlightAnnotation(evt) {
        const id = $(evt.currentTarget).data('id');
        const model = this.collection.get(id);
        if (model.get('displayed')) {
            this.parentView.trigger('h:highlightAnnotation', id);
        }
    },

    _unhighlightAnnotation() {
        this.parentView.trigger('h:highlightAnnotation');
    },

    _changeAnnotationHighlight(model) {
        this.$(`.h-annotation[data-id="${model.id}"]`).toggleClass('h-highlight-annotation', model.get('highlighted'));
    },

    _changeGlobalOpacity() {
        this._opacity = this.$('#h-annotation-opacity').val();
        this.$('.h-annotation-opacity-container')
            .attr('title', `Annotation total opacity ${(this._opacity * 100).toFixed()}%`);
        this.trigger('h:annotationOpacity', this._opacity);
    },

    _changeGlobalFillOpacity() {
        this._fillOpacity = this.$('#h-annotation-fill-opacity').val();
        this.$('.h-annotation-fill-opacity-container')
            .attr('title', `Annotation fill opacity ${(this._fillOpacity * 100).toFixed()}%`);
        this.trigger('h:annotationFillOpacity', this._fillOpacity);
    },

    _toggleExpandGroup(evt) {
        this.groupPosition = $(evt.currentTarget)[0].offsetTop;
        this.forGroup = 'group';
        this.forAnnotation = '';
        this.containerHeight.scrollTop(this.groupPosition);
        const name = $(evt.currentTarget).parent().data('groupName');
        if (this._expandedGroups.has(name)) {
            this._expandedGroups.delete(name);
        } else {
            this._expandedGroups.add(name);
        }
        this._debounceRender();
    },

    _getAnnotationGroups() {
        // Annotations without elements don't have any groups, so we inject the null group
        // so that they are displayed in the panel.
        this.collection.each((a) => {
            const groups = a.get('groups') || [];
            const groupName = a.get('groupName') || '';
            if (!groups.length && groupName == '') {
                groups.push(null);
            } else if (!groups.length && groupName != '') {
                groups.push(groupName);
            }
        });
        const groupObject = {};
        const groups = _.union(...this.collection.map((a) => a.get('groups')));
        _.each(groups, (group) => {
            const groupList = this.collection.filter(
                (a) => _.contains(a.get('groups'), group));

            if (group === null) {
                group = 'default';
            }
            groupObject[group] = _.sortBy(groupList, (a) => a.get('created'));
        });
        this._triggerGroupCountChange(groupObject);
        return groupObject;
    },

    _triggerGroupCountChange(groups) {
        const groupCount = {};
        _.each(groups, (annotations, name) => {
            if (name !== 'default') {
                groupCount[name] = annotations.length;
            } else {
                groupCount.default = annotations.length;
            }
        });
        this.trigger('h:groupCount', groupCount);
    },

    createAnnotationStyles() {
        restRequest({
            url: `item/${this.parentItem.id}`
        }).then((items) => {
            if (items.baseParentType === 'collection') {
                restRequest({
                    url: `/folder?parentType=collection&parentId=${items.baseParentId}`
                }).then((collection) => {
                    let meta = collection.find(c => c.name == 'meta');
                    if (meta) {
                        restRequest({
                            url: `/item?folderId=${meta._id}`
                        }).then((data) => {
                            let jsonData = data.find(d => d.name == 'annotation_styles.json');
                            if (jsonData) {
                                restRequest({
                                    url: `/item/${jsonData._id}/download?contentDisposition=inline`
                                }).then((styles) => {
                                    this._groups.fetch().done(() => {
                                        var group_models_ids = [];
                                        this._groups.models.forEach(model => {
                                            if(model.id != 'default'){
                                                group_models_ids.push(model.id);
                                            }
                                        });
                                        group_models_ids.forEach(model_id => {
                                            var model = this._groups.get(model_id);
                                            model.destroy();
                                            this._groups.remove(model);
                                            window.localStorage.removeItem(model_id);
                                        });
                                        styles.forEach(style => {
                                            this._annotationStyles = new StyleModel(style);
                                            this._groups.add(this._annotationStyles.toJSON());
                                            this._groups.get(this._annotationStyles.id).save();
                                            // To check if there are any annotation sets already present with the style group
                                            var annotationSet = this.collection.models.find(a => a.attributes.groups.indexOf(style.id) >= 0);
                                            if (annotationSet == undefined) {
                                                var model = new AnnotationModel({
                                                    itemId: this.parentItem.id,
                                                    annotation: {
                                                        name: style.id
                                                    }
                                                });
                                                model.save().done(() => {
                                                    //model.set('displayed', true);
                                                    model.attributes.groups.push(style.id);
                                                    this.collection.add(model);
                                                    var annData = {
                                                        name: style.id,
                                                        description: '',
                                                        elements: [{
                                                            group: style.id,
                                                            lineColor: style.lineColor,
                                                            fillColor: style.fillColor,
                                                            lineWidth: style.lineWidth,
                                                            type: "point",
                                                            center: [-100, -100, -100],
                                                            id: guid()
                                                        }]
                                                    };
                                                    if(style.label != undefined){
                                                        if ('value' in style.label) {
                                                            annData.elements[0]["label"] = {
                                                                value: style.label["value"]
                                                            }
                                                        }
                                                    }
                                                    restRequest({
                                                        url: `annotation/${model.id}`,
                                                        method: 'PUT',
                                                        data: JSON.stringify(annData),
                                                        contentType: 'application/json',
                                                        processData: false,
                                                    }).then((item) => {
                                                        //this._refreshAnnotations();
                                                    });
                                                });
                                            }
                                        });
                                    });
                                    //this._groups.remove('default');
                                });
                            }
                        });
                    }
                });
            }
        });
    }
});

export default AnnotationSelector;



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/panels/AnnotationSelector.js